import { Box } from '@chakra-ui/react';
import React from 'react';
import { scrollBarStyle } from '../../utils/layoutConfig';
import { JsonFormatter } from 'react-json-formatter';
import renderPageJson from '../../utils/generateJson';
import { useSelector } from 'react-redux';
import { selectedPageObject } from '../../redux/pagesSlice';

const JsonStyle = {
	propertyStyle: { color: '#9CDCFE' },
	colonStyle: { color: 'white' },
	braceStyle: { color: 'white' },
	commaStyle: { color: 'white' },
	bracketStyle: { color: 'white' },
	booleanTrueStyle: { color: '#4e94ce' },
	booleanFalseStyle: { color: '#4e94ce' },
	nullStyle: { color: '#4e94ce' },
	stringStyle: { color: '#CE9178' },
	numberStyle: { color: '#B5CEA8' },
};

const DebugBox = () => {
	const selectedPageObjectValue = useSelector(selectedPageObject);
	const [json, setJson] = React.useState(null);
	console.log(json);

	React.useEffect(() => {
		setJson(renderPageJson(selectedPageObjectValue));
	}, [selectedPageObjectValue]);

	return (
		<Box className="aeae" mt={'4px'} w="100%" h={'50%'} bg="white" order={3} mb={2} overflow={'hidden'}>
			<Box
				fontFamily={'Consolas'}
				fontSize={'sm'}
				h={'100%'}
				p={3}
				overflow={'auto'}
				sx={scrollBarStyle}
				bg={'#1e1e1e'}
			>
				<JsonFormatter json={JSON.stringify(json)} JsonStyle={JsonStyle} />
			</Box>
		</Box>
	);
};

export default DebugBox;
